const backend_domain = 'https://www.kanthasri.com';
const APIPATH = { 
    gettestdata :{
        url : `${backend_domain}/api/v1/test/test-data`,
        method : 'get'
    },
    getOTP :{
        url : `${backend_domain}/api/v1/auth/get-otp`,
        method : 'post'
    },
    validateOTP :{
        url : `${backend_domain}/api/v1/auth/validate-otp`,
        method : 'post'
    },
    signout :{
        url : `${backend_domain}/api/v1/auth/signout`,
        method : 'post'
    },
    getUser :{
        url : `${backend_domain}/api/v1/user/get-user`,
        method : 'get'
    },
    updateUser :{
        url : `${backend_domain}/api/v1/user/update-user`,
        method : 'post'
    },
    profileRequestOTP :{
        url : `${backend_domain}/api/v1/user/request-otp`,
        method : 'post'
    },
    profileValidateOTP :{
        url : `${backend_domain}/api/v1/user/validate-otp`,
        method : 'post'
    },
    createAddress :{
        url : `${backend_domain}/api/v1/user/address/create`,
        method : 'post'
    },
    updateAddress :{
        url : `${backend_domain}/api/v1/user/address/update`,
        method : 'post'
    },
    deleteAddress :{
        url : `${backend_domain}/api/v1/user/address/delete`,
        method : 'post'
    },
    getAddresses :{
        url : `${backend_domain}/api/v1/user/address/getaddresses`,
        method : 'get'
    },
    defaultAddress :{
        url : `${backend_domain}/api/v1/user/address/defaultaddress`,
        method : 'post'
    },
    getStates :{
        url : `${backend_domain}/api/v1/user/utility/getstates`,
        method : 'get'
    },
    getCountries :{
        url : `${backend_domain}/api/v1/user/utility/getCountries`,
        method : 'get'
    },
    getSingleProduct :{
        url : `${backend_domain}/api/v1/product/getsingleproduct`,
        method : 'post'
    },
    getProducts :{
        url : `${backend_domain}/api/v1/product/getproducts`,
        method : 'post'
    },
    getProductsBySearch :{
        url : `${backend_domain}/api/v1/product/getProductsBySearch`,
        method : 'post'
    }
    ,
    createProductReview :{
        url : `${backend_domain}/api/v1/user/review/create`,
        method : 'post'
    },
    getProductReview :{
        url : `${backend_domain}/api/v1/user/review/get`,
        method : 'post'
    },
    markHelpfulCount :{
        url : `${backend_domain}/api/v1/user/review/helpfulcount`,
        method : 'post'
    },
    verifyguestreviewaccess :{
        url : `${backend_domain}/api/v1/user/review/verifyguestreviewaccess`,
        method : 'post'
    }
    ,
    createWishlist :{
        url : `${backend_domain}/api/v1/user/wishlist/add`,
        method : 'post'
    },
    getWishlist :{
        url : `${backend_domain}/api/v1/user/wishlist/get`,
        method : 'get'
    },
    moveToCart :{
        url : `${backend_domain}/api/v1/user/wishlist/movetocart`,
        method : 'post'
    },
    addToCart :{
        url : `${backend_domain}/api/v1/user/cart/add`,
        method : 'post'
    },
    syncGuestCart :{
        url : `${backend_domain}/api/v1/user/cart/syncguestcart`,
        method : 'post'
    },
    getCoupons :{
        url : `${backend_domain}/api/v1/user/guest/getcoupons`,
        method : 'get'
    },
    
    getCartItems :{
        url : `${backend_domain}/api/v1/user/cart/get`,
        method : 'get'
    },
    updateCartItem :{
        url : `${backend_domain}/api/v1/user/cart/update`,
        method : 'post'
    },
    deleteCartItem :{
        url : `${backend_domain}/api/v1/user/cart/delete`,
        method : 'post'
    },
    updateShippingAddress :{
        url : `${backend_domain}/api/v1/user/cart/updateshippingaddress`,
        method : 'post'
    },
    applyCoupon :{
        url : `${backend_domain}/api/v1/user/cart/applyCoupon`,
        method : 'post'
    },
    removeCoupon :{
        url : `${backend_domain}/api/v1/user/cart/removeCoupon`,
        method : 'post'
    },
    updatePaymentMethod :{
        url : `${backend_domain}/api/v1/user/cart/updatepaymentmethod`,
        method : 'post'
    },
    createOrder :{
        url : `${backend_domain}/api/v1/user/order/ordercreate`,
        method : 'post'
    },
    getOrders :{
        url : `${backend_domain}/api/v1/user/order/getorders`,
        method : 'post'
    },
    getOrderDetails :{
        url : `${backend_domain}/api/v1/user/order/getorderdetails`,
        method : 'post'
    },
    makePayment :{
        url : `${backend_domain}/api/v1/user/payment/makepayment`,
        method : 'post'
    },
    checkPaymentStatus :{
        url : `${backend_domain}/api/v1/user/payment/checkpaymentstatus`,
        method : 'post'
    },
    getBlogBySlug :{
        url: `${backend_domain}/api/v1/blog/:slug`,
        method : 'get'
    },
    getAllBlogs: {
    url: `${backend_domain}/api/v1/blog/getAllBlogs`,
    method: 'get'
},
 getCertificateDetails :{
        url: `${backend_domain}/api/v1/digital/certificate`,
        method : 'post'
    },
     saveWholesaleInquiry :{
        url: `${backend_domain}/api/v1/wholesale/save-query`,
        method : 'post'
    },





    

}
export default APIPATH